import React from 'react';
import {connect} from 'react-redux';

import './ErrorPage.less';

import {Layout} from 'new-components/layout/Layout';
import {Block} from "compositions/block/Block.tsx";
import {Button} from "elements/button/Button";
import {reloadApp} from "helpers/error.helper";
import {BlockDescription} from "elements/block-description/BlockDescription";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {getTranslationsSelector} from "../../../selectors";

const ErrorPage = ({errorMessage, translations}) => {
	return <Layout>
		<div className="error-page">
			<div className="error-page__message">
				<Block title={getSafeTranslation('ErrorPage.messageBlockTitle', translations)}>
					<BlockDescription text={errorMessage}/>
				</Block>
			</div>
			<div className="error-page__reload">
				<Button onClick={() => reloadApp()}>
					{getSafeTranslation('ErrorPage.buttonCaption', translations)}
				</Button>
			</div>
		</div>
	</Layout>
}

function mapStateToProps(state) {
	return {
		translations: getTranslationsSelector(state)
	}
}

function mapDispatchToProps() {
	return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
